import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProjectLinkRenderer = (props) => {
  if (!props.data || props.data.id === undefined || props.data.id === null) {
    return null;
  }
  return (
    <Link to={`/crm/projects/${props.data.id}`} target="_blank">{props.value}</Link>
  );
};

ProjectLinkRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  value: PropTypes.node,
};

export default ProjectLinkRenderer;
